/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.la_systole_z_fml = exports.lvpwd_z_fml = exports.ivsd_z_fml = exports.bsa_fml = void 0;
// Calculates Body Surface Area of Patient
function bsa_fml(w, h) {
    return (Math.exp(0.3964 * Math.log(h)) * Math.exp(0.5378 * Math.log(w)) * 0.024265);
}
exports.bsa_fml = bsa_fml;
// Calculates Z-Score of Interventricular Septal Diameter
function ivsd_z_fml(ivsd, bsa) {
    return ((ivsd - (0.45686 * (bsa ** 0.59577) + 0.18722)) / (0.02033 + 0.04698 * bsa));
}
exports.ivsd_z_fml = ivsd_z_fml;
// Calculates Z-Score of Left Ventricular Posterior Wall Diameter
function lvpwd_z_fml(lvpwd, bsa) {
    return ((lvpwd - (0.3767 * (bsa ** 0.72326) + 0.243)) / (0.0371 + 0.02776 * bsa));
}
exports.lvpwd_z_fml = lvpwd_z_fml;
// Calculates Z-Score of Left Atrial Diameter at End Systole
function la_systole_z_fml(la, bsa) {
    return ((Math.log10(la) - Math.log10(10 ** (0.81375 * (bsa ** 0.20444) - 0.43308))) / (0.07447 - 0.01478 * bsa));
}
exports.la_systole_z_fml = la_systole_z_fml;



// WEBPACK FOOTER //
// ./demo/pages/components/primacy-cal-js/z_functions.js